import {SHOW_CHAT, HIDE_CHAT} from '../actions';

export default function chatVisible(state = false, action) {
  switch (action.type) {
    case SHOW_CHAT:
      return true;
    case HIDE_CHAT:
      return false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/chatVisible.js